import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './FloatingBubbleModal.css'; // Reutilizamos los mismos estilos
import { useSelector } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
import API_BASE_URL from '../config';


const FloatingGestionUsuariosModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [vuelos, setVuelos] = useState([]);
  const [search, setSearch] = useState('');
  const token = useSelector((state) => state.auth.token);
  const decoded = token ? jwtDecode(token) : {};
  const estacionUsuario = decoded.estacion?.trim().toUpperCase() || 'SIN_ESTACION';

  const fetchVuelos = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}api/servicios/vuelos-operadores?estacion=${estacionUsuario}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setVuelos(response.data);
    } catch (error) {
      console.error('Error al obtener vuelos:', error);
    }
  };

  useEffect(() => {
    if (isModalOpen) {
      fetchVuelos();
    }
  }, [isModalOpen]);

  const filteredVuelos = vuelos.filter((vuelo) =>
    vuelo.noVuelo.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      {/* Burbuja flotante nueva */}
      <div
        className={`floating-bubble gestion ${isModalOpen ? 'bubble-active' : ''}`}
        onClick={() => setIsModalOpen(!isModalOpen)}
      >
        👤📋
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal modal-animate-in">
            <div className="modal-header">
              <h2>Gestión Usuarios por Vuelo</h2>
              <button
                className="close-button"
                onClick={() => setIsModalOpen(false)}
              >
                ✖
              </button>
            </div>

            {/* Buscador de vuelos */}
            <div className="modal-body">
              <input
                type="text"
                placeholder="Buscar número de vuelo..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{
                  width: '100%',
                  padding: '8px',
                  marginBottom: '10px',
                  borderRadius: '8px',
                  border: '1px solid #ccc',
                }}
              />

              {/* Tarjetas de vuelos */}
              {filteredVuelos.length > 0 ? (
                filteredVuelos.map((vuelo, index) => (
                  <div key={index} className="flight-card">
                    <h3>{vuelo.aerolinea} {vuelo.noVuelo} - {vuelo.tipoService}</h3>
                    <p><strong>Fecha:</strong> {vuelo.fechaInput}</p>
                    <p><strong>Siglas asignadas:</strong> {vuelo.siglas}</p>
                  </div>
                ))
              ) : (
                <p style={{ textAlign: 'center', marginTop: '20px' }}>No se encontraron vuelos.</p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FloatingGestionUsuariosModal;
